import { not } from 'ramda';
import React, { useEffect, useCallback, useState } from 'react';
export var CloseState;

(function (CloseState) {
  CloseState["Open"] = "open";
  CloseState["Closing"] = "closing";
  CloseState["Closed"] = "closed";
})(CloseState || (CloseState = {}));

export var useCloseHandlers = function useCloseHandlers(_ref) {
  var afterClose = _ref.afterClose,
      autoDismiss = _ref.autoDismiss,
      container = _ref.container,
      show = _ref.show;

  var _useState = useState(show ? CloseState.Open : CloseState.Closed),
      closeState = _useState[0],
      setCloseState = _useState[1];

  var afterAnimation = useAfterAnimation(container.current);
  var unmounted = React.useRef();
  useEffect(function () {
    unmounted.current = false;
    return function () {
      unmounted.current = true;
    };
  }, []);

  var safeSetCloseState = function safeSetCloseState(newCloseState) {
    if (unmounted.current) {
      return;
    }

    setCloseState(newCloseState);
  };

  var handleClose = useCallback(function () {
    safeSetCloseState(CloseState.Closing);
    afterAnimation(function () {
      safeSetCloseState(CloseState.Closed);

      if (afterClose) {
        afterClose();
      }
    });
  }, [afterAnimation, afterClose]);
  useEffect(function () {
    var autoDismissToastDuration = 3000;

    if (autoDismiss && show) {
      setTimeout(handleClose, autoDismissToastDuration);
    }
  }, [autoDismiss, show, handleClose]);
  useEffect(function () {
    if (not(show) && closeState === CloseState.Open) {
      handleClose();
    } else if (show && closeState === CloseState.Closed) {
      safeSetCloseState(CloseState.Open);
    } else if (show && closeState === CloseState.Closing) {
      afterAnimation(function () {
        safeSetCloseState(CloseState.Open);
      });
    }
  }, [show, afterAnimation, closeState, handleClose]);
  return {
    closeState: closeState,
    handleClose: handleClose
  };
};

var useAfterAnimation = function useAfterAnimation(container) {
  return useCallback(function (cb) {
    if (container && cb) {
      container.addEventListener('animationend', cb, {
        once: true
      });
    }
  }, [container]);
};